import { useEffect } from "react";
import "./prodEntradas.css";
import { useStoreEntrada } from "./useStoreEntradas";
import { MensajeError, useWindowDimensions } from "../../componentes/FuncionesLocales";
import { TabMenu } from "primereact/tabmenu";
import EntradasTab1 from "./EntradasTab1";
import EntradasTab2 from "./EntradasTab2";
import { useStoreLogin } from "../Login/useStoreLogin";
import { useStoreHome } from "../Home/useStoreHome";
import { useNavigate } from "react-router-dom";

const ProdEntradas = () => {
  const EntradaOk = useStoreEntrada((state) => state.EntradaOk);
  const Fecha = useStoreEntrada((state) => state.Fecha);
  const TabSeleccionado = useStoreEntrada((state) => state.TabSeleccionado);
  const FechaCaducidad = useStoreHome((state) => state.FechaCaducidad);
  const navigate = useNavigate();

  const { width } = useWindowDimensions();

  useEffect(() => {
    if (!useStoreLogin.getState().validarVariablesGlobales()) {
      useStoreLogin.getState().logout();
    }
    useStoreEntrada.getState().getProcesos();
    useStoreEntrada.getState().getListaEntradasGrillaPantalla();
  }, []);

  useEffect(() => {
    if (FechaCaducidad) {
      if (FechaCaducidad < new Date()) {
        MensajeError(
          "La licencia de uso ha caducado. Contacte a soporte técnico.",
        );
        navigate("/home");
      }
    }
  }, [FechaCaducidad, navigate]);

  useEffect(() => {
    useStoreEntrada.getState().getListaEntradasGrillaPantalla();
  }, [Fecha]);

  useEffect(() => {
    if (EntradaOk) {
      useStoreEntrada.setState({ EntradaOk: false });
      useStoreEntrada.getState().getListaEntradasGrillaPantalla();
    }
  }, [EntradaOk]);

  const items = [
    { label: "Materia Prima/Insumos", icon: "pi pi-box" },
    { label: "Detalles", icon: "pi pi-list" },
  ];

  return (
    <div className="prod-entradas  ">
      <div
        className="prod-header"
        style={{
          backgroundColor: "#005C44",
          padding: "12px 16px",
          borderRadius: "8px",
          color: "#fff",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
        }}
      >
        <span className="modulo-icono" aria-hidden="true"><i className="pi pi-arrow-circle-down" /></span>
        <div>
          <h2
            className="prod-titulo"
            style={{
              color: "#f4f4f4ff",
              textShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
            }}
          >
            Producción Entradas
          </h2>
          <p
            className="prod-parrafo"
            style={{
              color: "#f4f4f4ff",
              textShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
            }}
          >
            Da de baja del stock las materias primas e insumos utilizadas para
            la producción
          </p>
        </div>

        <div className="btn-play" style={{ marginLeft: "auto" }}>
        </div>
      </div>

      {width < 768 ? (
        <div className="prod-content-scroll">
          <TabMenu
            model={items}
            activeIndex={Number(TabSeleccionado)}
            onTabChange={(e) =>
              useStoreEntrada.setState({ TabSeleccionado: e.index })
            }
          />
          <div className="prod-layout animado-entrada">
            {TabSeleccionado === 0 && (
              <div className="prod-formulario">
                <EntradasTab1 />
              </div>
            )}
            {TabSeleccionado === 1 && (
              <div className="prod-registros">
                <EntradasTab2 />
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="prod-content-scroll">
          {" "}
          {/* ← esto faltaba en desktop */}
          <div className="prod-layout animado-entrada">
            <div className="prod-formulario">
              <EntradasTab1 />
            </div>
            <div className="prod-registros">
              <EntradasTab2 />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProdEntradas;
